export enum ClaimGoogleTransLang {
    CN = 'CN',
    EN = 'EN',
    JP = 'JP',
    DEFAULT = 'DEFAULT',
}

export enum StreamStatus {
    PROGRESS_INIT = 'INIT',
    PROGRESS_START = 'ACTION',
    PROCESSING = 'PROCESSING',
    FINISH = 'FINISH',
    ERROR = 'ERROR'
}

export enum TransSourcePatent {
    CLAIM = 'CLAIM',
    COMPARE = 'DESC',
}

export enum TransSourcePatentKey {
    CLAIM = 'claimVal',
    COMPARE = 'compareVal',
}
